module.exports = __webpack_public_path__ + "static/media/mv.2fa6ac06.svg";